import moment from "moment";

export const getReleaseDate = (announcement) => {
  const value = announcement.release_date;
  return typeof value === "string" && moment(value, "YYYY-MM-DD", true).isValid()
    ? value
    : null;
};

export const getAnnouncementDate = (announcement) =>
  getReleaseDate(announcement) || announcement.created_on || announcement.created_at || announcement.created_date;

const timestamp = (announcement) => {
  const value = getAnnouncementDate(announcement);
  return value && moment(value).isValid() ? moment(value).valueOf() : 0;
};

export const sortAnnouncements = (announcements) => [...announcements].sort((a, b) => timestamp(b) - timestamp(a));

export const isNewAnnouncement = (announcement) => {
  const date = timestamp(announcement);
  return date > moment().subtract(30, "days").valueOf() && date <= Date.now();
};

export const safeExternalUrl = (value) => {
  try {
    const url = new URL(value);
    return ["https:", "http:"].includes(url.protocol) ? url.href : null;
  } catch {
    return null;
  }
};
